import { useContext } from 'react';
import PropTypes from 'prop-types';
import User from '../../models/User';
import CanContext from '../../containers/Can/CanContext';

function Can({ children, checkPermission, incidentId, failTo }) {
    let can = false;
    const canContext = useContext(CanContext);
    incidentId = incidentId || (canContext && canContext.currentIncidentId);

    if (!!incidentId) {
        can =
            User.can(
                'all_permissions',
                canContext.currentIncidentPermissions
            ) ||
            User.can(checkPermission, canContext.currentIncidentPermissions);
    } else if (checkPermission && User.can(checkPermission)) {
        can = true;
    }

    if (can) return children;
    if (failTo) return failTo;
    return null;
}

Can.propTypes = {
    checkPermission: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    incidentId: PropTypes.number,
    failTo: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string
    ])
};

export default Can;
